import Chapter1Lesson1 from './chapter1/lesson1.vue'
import Chapter1Lesson2 from './chapter1/lesson2.vue'
import Chapter1Lesson3 from './chapter1/lesson3.vue'
import Chapter1Lesson4 from './chapter1/lesson4.vue'
import Chapter2Lesson1 from './chapter2/lesson1.vue'
import Chapter2Lesson2 from './chapter2/lesson2.vue'

export const books = [
  {
    id: 1,
    title: 'Code, Ship, Watch',
    description: 'Learn the fundamentals of modern development practices, from setting up your development environment to advanced monitoring and CI/CD integration.',
    chapters: [
      {
        id: 1,
        title: 'Setting up the developer machine',
        lessons: [
          {
            id: 1,
            title: 'Homebrew',
            component: Chapter1Lesson1
          },
          {
            id: 2,
            title: 'AWS CLI',
            component: Chapter1Lesson2
          },
          {
            id: 3,
            title: 'Terraform',
            component: Chapter1Lesson3
          },
          {
            id: 4,
            title: 'Git',
            component: Chapter1Lesson4
          }
        ]
      },
      {
        id: 2,
        title: 'Advanced Features',
        lessons: [
          {
            id: 1,
            title: 'Advanced Monitoring Features',
            component: Chapter2Lesson1
          },
          {
            id: 2,
            title: 'CI/CD Pipeline Integration',
            component: Chapter2Lesson2
          }
        ]
      }
    ]
  },
  {
    id: 2,
    title: 'Advanced Topics',
    description: 'Dive deeper into advanced development concepts, architecture patterns, and cutting-edge technologies.',
    chapters: [
      // Future chapters for Book 2 can be added here
    ]
  }
]

// Keep the old chapters export for backward compatibility during transition
export const chapters = books[0].chapters

// New book-based functions
export function getBook(bookId) {
  return books.find(book => book.id === bookId)
}

export function getChapter(bookId, chapterId) {
  const book = getBook(bookId)
  if (!book) return null
  return book.chapters.find(chapter => chapter.id === chapterId)
}

export function getLesson(bookId, chapterId, lessonId) {
  const chapter = getChapter(bookId, chapterId)
  if (!chapter) return null
  return chapter.lessons.find(lesson => lesson.id === lessonId)
}

export function getNextLesson(bookId, chapterId, lessonId) {
  const book = getBook(bookId)
  if (!book) return null
  
  const chapter = getChapter(bookId, chapterId)
  if (!chapter) return null

  const currentLessonIndex = chapter.lessons.findIndex(lesson => lesson.id === lessonId)
  if (currentLessonIndex === -1) return null

  // If there's another lesson in the current chapter
  if (currentLessonIndex < chapter.lessons.length - 1) {
    return {
      bookId,
      chapterId,
      lessonId: chapter.lessons[currentLessonIndex + 1].id
    }
  }

  // If there's another chapter in the current book
  const nextChapterIndex = book.chapters.findIndex(c => c.id === chapterId) + 1
  if (nextChapterIndex < book.chapters.length) {
    return {
      bookId,
      chapterId: book.chapters[nextChapterIndex].id,
      lessonId: book.chapters[nextChapterIndex].lessons[0].id
    }
  }

  return null
}

export function getPreviousLesson(bookId, chapterId, lessonId) {
  const book = getBook(bookId)
  if (!book) return null
  
  const chapter = getChapter(bookId, chapterId)
  if (!chapter) return null

  const currentLessonIndex = chapter.lessons.findIndex(lesson => lesson.id === lessonId)
  if (currentLessonIndex === -1) return null

  // If there's a previous lesson in the current chapter
  if (currentLessonIndex > 0) {
    return {
      bookId,
      chapterId,
      lessonId: chapter.lessons[currentLessonIndex - 1].id
    }
  }

  // If there's a previous chapter in the current book
  const prevChapterIndex = book.chapters.findIndex(c => c.id === chapterId) - 1
  if (prevChapterIndex >= 0) {
    const prevChapter = book.chapters[prevChapterIndex]
    return {
      bookId,
      chapterId: prevChapter.id,
      lessonId: prevChapter.lessons[prevChapter.lessons.length - 1].id
    }
  }

  return null
}

// Legacy functions for backward compatibility (will be removed after migration)
export function getChapterLegacy(chapterId) {
  return chapters.find(chapter => chapter.id === chapterId)
}

export function getLessonLegacy(chapterId, lessonId) {
  const chapter = getChapterLegacy(chapterId)
  if (!chapter) return null
  return chapter.lessons.find(lesson => lesson.id === lessonId)
} 